import React from 'react';
import { useGroups } from '../../../../redux/groups/hooks/useGroups';
import { CircularProgress } from '@mui/material';
import { Navigate, useParams } from 'react-router-dom';

export function MerchandiserRedirect() {
  const params = useParams();
  const { groupId } = params;
  const { isLoading, data: groups } = useGroups();
  const groupToSearch = groupId || groups?.[0]?.id;

  if (isLoading) {
    return <CircularProgress sx={{ alignContent: 'center' }} />;
  }
  return groups?.length === 1 ? (
    <Navigate to={`/merchandiser/${groupToSearch}`} replace />
  ) : (
    <Navigate to="/storelist" replace />
  );
}
